import { useDispatch } from 'react-redux'
import { useQueryClient } from 'react-query'
import { useModals } from 'almanac-ui/Modal'

import { workspacesSet } from 'redux/actions'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { useWorkspaces } from 'hooks/useWorkspaces'
import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { filesKeys } from 'hooks/queries/files/filesKeys'
import { ConfirmApprovalsModal } from 'components/Settings/Workspace/AutopilotSettings/ConfirmApprovalsModal/ConfirmApprovalsModal'

export const useTogglePostApproval = () => {
  const dispatch = useDispatch()
  const queryClient = useQueryClient()
  const workspace = useCurrentWorkspace()
  const workspaces = useWorkspaces()
  const { openModal, closeModal } = useModals()

  const toggleApprovals = async () => {
    if (!workspace) return

    const isPostApprovalEnabled = !!workspace.post_approval_enabled

    dispatch(
      workspacesSet(
        workspaces.map((ws) =>
          ws.id === workspace.id
            ? {
                ...ws,
                post_approval_enabled: !isPostApprovalEnabled,
              }
            : ws,
        ),
      ),
    )

    const res = await sendToApi<void>(`/w/${workspace.id}/update`, {
      method: 'PUT',
      body: {
        post_approval_enabled: !isPostApprovalEnabled,
      },
    })

    if (res.type !== SUCCESS_RESPONSE_TYPE) {
      showToastMessage("We couldn't save your settings.", 'error')
      dispatch(
        workspacesSet(
          workspaces.map((ws) =>
            ws.id === workspace.id
              ? {
                  ...ws,
                  post_approval_enabled: workspace.post_approval_enabled,
                }
              : ws,
          ),
        ),
      )
    }

    queryClient.invalidateQueries(filesKeys.all(workspace.id))
  }

  const togglePostApproval = () => {
    if (!workspace) return

    openModal(
      ConfirmApprovalsModal,
      {
        enabled: !!workspace.post_approval_enabled,
        onConfirm: () => {
          toggleApprovals()
          closeModal()
        },
      },
      { newStack: true },
    )
  }

  return togglePostApproval
}
